class HeaderScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.scrollOffset =
      this.dataset.scrollOffset !== undefined
        ? parseFloat(this.dataset.scrollOffset)
        : 50
    this.safeZone =
      this.dataset.safeZone !== undefined
        ? parseFloat(this.dataset.safeZone)
        : 500
    window.theme.safeZone = this.safeZone

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.offsetTrackedY = 0

    // Track search scroll state
    this.searchScrollState = {
      searchInnerHidden: false,
      bannerHidden: false,
      lastScrollY: 0,
      offsetTrackedY: 0,
      scrollDirection: '',
    }

    document.body.style.setProperty(
      '--Header_Bottom_Position',
      `${Math.max(0, this.getBoundingClientRect().bottom)}px`,
    )

    this.setVariables()

    // eslint-disable-next-line compat/compat
    this.headerResizeObserver = new ResizeObserver(() => this.setVariables())
    this.headerResizeObserver.observe(this)
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this.headerResizeObserver?.disconnect()
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.onSearchScroll = this.onSearchScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })

    // Add search results scroll listener
    if (this.externalEls?.searchBody?.exists) {
      this.externalEls.searchBody.element.addEventListener(
        'scroll',
        this.onSearchScroll,
        { passive: true },
      )
    }

    this.els.icon?.elements.forEach(el => {
      this.listeners.add(el, 'mouseenter', this.onIconHover.bind(this))
      this.listeners.add(el, 'mouseleave', this.onIconBlur.bind(this))
    })
  }

  onIconHover (e) {
    const button = e.target.closest('[data-header-scroll-el="icon"]')
    const textContainer = button.querySelector('.hd-Banner_IconTextContainer')
    const text = button.querySelector('.hd-Banner_IconText')

    textContainer.style.width = `${text.getBoundingClientRect().width}px`
  }

  onIconBlur (e) {
    const button = e.target.closest('[data-header-scroll-el="icon"]')
    const textContainer = button.querySelector('.hd-Banner_IconTextContainer')

    textContainer.style.width = '0px'
  }

  onSearchScroll () {
    this.requestTick()
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    const previousDirection = this.scrollDirection

    this.lastKnownY = window.scrollY

    if (previouslyKnown !== this.lastKnownY) {
      this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'
    }

    if (previousDirection !== this.scrollDirection) {
      this.offsetTrackedY = this.lastKnownY
    }

    this.requestTick()
  }

  resetSearchScroll () {
    this.searchScrollState = {
      searchInnerHidden: false,
      bannerHidden: false,
      lastScrollY: 0,
      offsetTrackedY: 0,
      scrollDirection: '',
    }

    // Remove all scroll-related classes and variables
    // this.externalEls.searchInner?.element?.classList.remove(
    //   'hd-Search_Inner-hidden',
    // )
    this.externalEls.searchHeader?.element?.classList.remove(
      'clc-ProductGrid_HeaderContainer-sticky',
    )
    this.externalEls.searchBody?.element?.style.removeProperty(
      '--Search_Inner_Height',
    )

    document.body.classList.remove(
      'hd-Search_Banner-hidden',
      'lyt-Header-hidden',
      'lyt-Header-scrolled',
    )
    document.body.style.removeProperty('--Sticky_Header_Height')
    document.body.style.removeProperty('--AnnouncementBarScrollOffset')
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.pastAnnouncement()

    this.setSize()
    this.setVisibility()

    if (this.externalEls?.collectionHeader?.exists) {
      this.handleCollectionHeader()
    }

    if (this.externalEls?.searchHeader?.exists) {
      this.handleSearchHeader()
    }

    if (this.externalEls?.wishlistHeader?.exists) {
      this.handleWishlistHeader()
    }

    this.setVariables()
  }

  pastAnnouncement () {
    const announcementSize = this.els?.announcement?.exists
      ? this.els.announcement.element.offsetHeight
      : 10

    document.body.classList.toggle(
      this.dataset.classSolid,
      this.lastKnownY > announcementSize,
    )
  }

  setSize () {
    document.body.classList.toggle(
      this.dataset.classScrolled,
      this.headerIsScrolled,
    )
  }

  setVisibility () {
    if (document.body.classList.contains('template-index')) {
      document.body.classList.toggle(
        !this.dataset.classHidden,
        this.shouldBeVisible,
      )
      return
    }

    document.body.classList.toggle(
      this.dataset.classHidden,
      !this.shouldBeVisible,
    )
  }

  setVariables () {
    // Only update when header is visible to avoid fighting with transform animations
    if (this.shouldBeVisible || this.lastKnownY <= this.safeZone) {
      document.body.style.setProperty(
        '--Header_Bottom_Position',
        `${this.headerBottomPosition}px`,
      )
    }

    document.body.style.setProperty(
      '--Sticky_Header_Height',
      `${this.offsetHeight}px`,
    )
    document.body.style.setProperty(
      '--Sticky_Header_Visible_Offset',
      `${this.shouldBeVisible ? this.offsetHeight : 0}px`,
    )
    document.body.dataset.headerVisible = this.shouldBeVisible
      ? 'true'
      : 'false'
  }

  handleCollectionHeader () {
    const headerStickyClass = 'lyt-Header-sticky'
    const headerHiddenClass = 'lyt-Header-hidden'
    const collectionStickyClass = 'clc-ProductGrid_HeaderContainer-sticky'
    const el = this.externalEls.collectionHeader.element
    const difference = (this.offsetHeight - this.collectionBodyPosition) * -1

    if (this.collectionBodyPosition <= this.offsetHeight) {
      if (this.hasMakersHero) {
        if (difference <= 0 && difference >= this.offsetHeight * 2) return

        this.style.top = `${difference}px`

        if (this.collectionBodyPosition <= 0) {
          el.style.top = 0

          document.body.classList.add(headerHiddenClass)
        } else {
          el.style.top = `${difference}px`

          document.body.classList.remove(headerHiddenClass)
        }

        document.body.classList.add(headerStickyClass)
      }

      el.classList.add(collectionStickyClass)
    } else {
      if (this.hasMakersHero) {
        this.style.top = 0

        document.body.classList.remove(headerStickyClass)
      }

      el.classList.remove(collectionStickyClass)
    }
  }

  shouldHideOnSearchScroll (scrollTop, threshold) {
    // If we haven't scrolled past threshold yet, don't hide
    if (scrollTop <= threshold) {
      return false
    }

    // Apply same offset logic as main header scroll
    const scrollOffset = this.scrollOffset // 50px
    const direction = this.searchScrollState.scrollDirection
    const trackedY = this.searchScrollState.offsetTrackedY

    if (direction === 'down') {
      return scrollTop > threshold + scrollOffset
    } else if (direction === 'up') {
      return scrollTop > trackedY - scrollOffset
    }
  }

  handleSearchHeader () {
    const headerStickyClass = 'clc-ProductGrid_HeaderContainer-sticky'

    // Track scroll direction (same pattern as main scroll)
    const scrollTop = this.externalEls.searchBody.element.scrollTop
    const previousScrollY = this.searchScrollState.lastScrollY
    const previousDirection = this.searchScrollState.scrollDirection

    this.searchScrollState.lastScrollY = scrollTop
    this.searchScrollState.scrollDirection =
      previousScrollY < scrollTop ? 'down' : 'up'

    if (previousDirection !== this.searchScrollState.scrollDirection) {
      this.searchScrollState.offsetTrackedY = scrollTop
    }

    // Get thresholds
    const searchInnerThreshold = window.width < 768 ? 53 : 0
    const bannerThreshold = 200

    // Determine scroll state with direction logic
    const shouldHideBanner = this.shouldHideOnSearchScroll(
      scrollTop,
      bannerThreshold,
    )

    // Sticky header should stay visible as long as scrolled past threshold
    const shouldBeSticky = scrollTop > searchInnerThreshold

    // Always keep sticky header in sync with scroll position
    const wasStickyBefore = this.externalEls.searchHeader.element.classList.contains(
      headerStickyClass,
    )
    this.externalEls.searchHeader.element.classList.toggle(
      headerStickyClass,
      shouldBeSticky,
    )
    // Sticky toggle causes layout reflow which resets scrollTop - restore to prevent feedback loop
    if (wasStickyBefore !== shouldBeSticky) {
      this.externalEls.searchBody.element.scrollTop = scrollTop
    }

    // Only update if banner state has changed
    if (shouldHideBanner !== this.searchScrollState.bannerHidden) {
      this.searchScrollState.bannerHidden = shouldHideBanner

      document.body.classList.toggle(
        'hd-Search_Banner-hidden',
        shouldHideBanner,
      )
      document.body.classList.toggle('lyt-Header-hidden', shouldHideBanner)
      document.body.classList.toggle('lyt-Header-scrolled', shouldHideBanner)
    }
  }

  handleWishlistHeader () {
    const stickyClass = 'ku-ProductGrid_HeaderContainer-sticky'
    const el = this.externalEls.wishlistHeader.element

    const thresholdAmount = 95

    if (this.wishlistBodyPosition <= thresholdAmount) {
      el.classList.add(stickyClass)
    } else {
      el.classList.remove(stickyClass)
    }
  }

  get shouldBeVisible () {
    if (this.hasMakersHero && this.scrollDirection === 'down') {
      const makersHero = this.externalEls.makersHero.element
      const brandsHeroHeight = Number(
        `-${makersHero.getBoundingClientRect().height}`,
      )

      if (
        makersHero.getBoundingClientRect().y - this.offsetHeight <
        brandsHeroHeight
      ) {
        return false
      } else {
        return true
      }
    }

    if (this.lastKnownY <= this.safeZone) {
      return true
    }

    if (
      this.hasMakersHero &&
      this.collectionBodyPosition >= this.offsetHeight
    ) {
      return true
    }

    if (this.scrollDirection === 'down') {
      return !this.isOverOffset
    } else if (this.scrollDirection === 'up') {
      return this.isOverOffset
    }
  }

  get isOverOffset () {
    if (this.scrollDirection === 'down') {
      return this.lastKnownY >= this.offsetTrackedY + this.scrollOffset
    } else if (this.scrollDirection === 'up') {
      return this.lastKnownY <= this.offsetTrackedY - this.scrollOffset
    }
  }

  get headerIsScrolled () {
    return this.lastKnownY > this.offsetHeight + 40
  }

  get headerBottomPosition () {
    const position = this.getBoundingClientRect().bottom

    if (position < 0) return 0

    return position
  }

  get hasMakersHero () {
    return false
    // return this.externalEls?.makersHero?.exists
  }

  get collectionBodyPosition () {
    return this.externalEls.collectionBody !== undefined
      ? this.externalEls.collectionBody.element.getBoundingClientRect().top
      : 0
  }

  get searchBodyPosition () {
    return this.externalEls?.searchBody.element.getBoundingClientRect().top
  }

  get wishlistBodyPosition () {
    return this.externalEls?.wishlistBody.element.getBoundingClientRect().top
  }
}

if (!customElements.get('header-scroll')) {
  customElements.define('header-scroll', HeaderScroll)
}
